import { render } from "./FlyDataLogoIcon.vue?vue&type=template&id=745d60b8"
import script from "./FlyDataLogoIcon.vue?vue&type=script&lang=js"
export * from "./FlyDataLogoIcon.vue?vue&type=script&lang=js"

import "./FlyDataLogoIcon.vue?vue&type=style&index=0&id=745d60b8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__